// extracted by mini-css-extract-plugin
module.exports = {"container":"Content_container__r34wA","main":"Content_main__1wh_P"};